export const HOME_ACTION = "HOME_ACTION";
export const SHOP_ACTION = "SHOP_ACTION";
export const COMMON_CONTENT_ACTION = "COMMON_CONTENT_ACTION";
export const HOME_ACTION_LOADER = "HOME_ACTION_LOADER";
export const SHOP_ACTION_LOADER = "SHOP_ACTION_LOADER";
export const SHOP_DETAIL_ACTION = "SHOP_DETAIL_ACTION";
export const SHOP_DETAIL_ACTION_LOADER = "SHOP_DETAIL_ACTION_LOADER";
export const CART_ACTION = "CART_ACTION";
export const CART_ACTION_LOADER = "CART_ACTION_LOADER";
export const ADD_TO_CART_ACTION = "ADD_TO_CART_ACTION";
export const CLEAR_CART_MESSAGE = 'CLEAR_CART_MESSAGE';
export const SHOP_DETAIL_RESET = "SHOP_DETAIL_RESET";
export const ADD_TO_CART_ACTION_LOADER = "ADD_TO_CART_ACTION_LOADER";
export const COMMON_CONTENT_ACTION_LOADER = "COMMON_COOTENT_ACTION_LOADER";
export const CHECKOUT_ACTION_LOADER = "CHECKOUT_ACTION_LOADER";
export const CHECKOUT_DETAIL_ACTION = "CHECKOUT_DETAIL_ACTION";
export const PLACE_ORDER_ACTION_LOADER = "PLACE_ORDER_ACTION_LOADER";
export const PLACE_ORDER_ACTION = "PLACE_ORDER_ACTION";
export const THANK_YOU_ACTION = "THANK_YOU_ACTION";
export const THANK_YOU_ACTION_LOADER = "THANK_YOU_ACTION_LOADER";
export const CONTACT_PAGE_LOADER = "CONTACT_PAGE_LOADER";
export const CONTACT_PAGE_ACTION = "CONTACT_PAGE_ACTION";
export const DATA_PROTECTION_PAGE_ACTION = "DATA_PROTECTION_PAGE_ACTION";
export const DATA_PROTECTION_PAGE_LOADER = "DATA_PROTECTION_PAGE_LOADER";
export const TERMS_CONDITIONS_PAGE_ACTION = "TERMS_CONDITIONS_PAGE_ACTION";
export const TERMS_CONDITIONS_PAGE_LOADER = "TERMS_CONDITIONS_PAGE_LOADER";
export const GALLERY_COLLECTION_PAGE_ACTION = "GALLERY_COLLECTION_PAGE_ACTION";
export const GALLERY_COLLECTION_PAGE_LOADER = "GALLERY_COLLECTION_PAGE_LOADER";
export const OUR_LABS_PAGE_ACTION = "OUR_LABS_PAGE_ACTION";
export const OUR_LABS_PAGE_LOADER = "OUR_LABS_PAGE_LOADER";
export const FRAMES_PAGE_LOADER = "FRAMES_PAGE_LOADER";
export const FRAMES_PAGE_ACTION = "FRAMES_PAGE_ACTION";
export const QUALITY_PAGE_ACTION = "QUALITY_PAGE_ACTION";
export const QUALITY_PAGE_LOADER = "QUALITY_PAGE_LOADER";

export const SIGNUP_ACTION = 'SIGNUP_ACTION';
export const SIGNUP_ACTION_LOADER = 'SIGNUP_ACTION_LOADER';
export const LOGIN_ACTION = 'LOGIN_ACTION';
export const LOGIN_ACTION_LOADER = 'LOGIN_ACTION_LOADER';
export const LOGOUT_ACTION = 'LOGOUT_ACTION';
export const CHECK_AUTH_ACTION = 'CHECK_AUTH_ACTION';
export const CLEAR_AUTH_MESSAGES = 'CLEAR_AUTH_MESSAGES';
export const ORDER_DETAIL_ACTION_LOADER = 'ORDER_DETAIL_ACTION_LOADER';
export const ORDER_DETAIL_ACTION = 'ORDER_DETAIL_ACTION';
export const UPDATE_CUSTOMER_ACTION = 'UPDATE_CUSTOMER_ACTION';
export const UPDATE_CUSTOMER_ACTION_LOADER = 'UPDATE_CUSTOMER_ACTION_LOADER';
export const ADD_TO_WISHLIST_ACTION = 'ADD_TO_WISHLIST_ACTION';
export const ADD_TO_WISHLIST_ACTION_LOADER = 'ADD_TO_WISHLIST_ACTION_LOADER';
export const WISHLIST_ACTION = 'WISHLIST_ACTION';
export const WISHLIST_ACTION_LOADER = 'WISHLIST_ACTION_LOADER';
export const CLEAR_WISHLIST_MESSAGE = 'CLEAR_WISHLIST_MESSAGE';

export const ADD_ADDRESS_ACTION = 'ADD_ADDRESS_ACTION';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';

export const DELETE_ADDRESS_ACTION = 'DELETE_ADDRESS_ACTION';
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS';
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE';

export const UPDATE_ADDRESS_ACTION = 'UPDATE_ADDRESS_ACTION';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE';

export const CREDIT_SLIP_ACTION_LOADER = 'CREDIT_SLIP_ACTION_LOADER';
export const CREDIT_SLIP_ACTION = 'CREDIT_SLIP_ACTION';

export const VAT_VALIDATION_ACTION = "VAT_VALIDATION_ACTION";
export const VAT_VALIDATION_SUCCESS = "VAT_VALIDATION_SUCCESS";
export const VAT_VALIDATION_ERROR = "VAT_VALIDATION_ERROR";

export const PLACE_ORDER_CARD_ACTION = 'PLACE_ORDER_CARD_ACTION';
export const PLACE_ORDER_CARD_LOADER = 'PLACE_ORDER_CARD_LOADER';

export const FORGOT_PASSWORD_ACTION = 'FORGOT_PASSWORD_ACTION';
export const FORGOT_PASSWORD_ACTION_LOADER = 'FORGOT_PASSWORD_ACTION_LOADER';

export const RESET_PASSWORD_ACTION = 'RESET_PASSWORD_ACTION';
export const RESET_PASSWORD_ACTION_LOADER = 'RESET_PASSWORD_ACTION_LOADER';


export const FETCH_LANGUAGES_REQUEST = "FETCH_LANGUAGES_REQUEST";
export const FETCH_LANGUAGES_SUCCESS = "FETCH_LANGUAGES_SUCCESS";
export const FETCH_LANGUAGES_FAILURE = "FETCH_LANGUAGES_FAILURE";

